import {MonsterType} from "./CardTypes";

export function getBarShifts(monsterType: MonsterType): {
    healthX: number,
    healthY: number,
    speedValueX: number,
    speedValueY: number,
} {
    if (monsterType === MonsterType.SIMPLE) {
        return {
            healthX: 0,
            healthY: 0,
            speedValueX: 0,
            speedValueY: 0
        }
    }
    else if (monsterType === MonsterType.BOSS) {
        return {
            healthX: 12,
            healthY: 0,
            speedValueX: 12,
            speedValueY: -24
        }
    }
    else {
        throw new Error(`Unknown monster type: ${monsterType}`)
    }
}